/*
 后台管理系统主路由组件
 */
import React, {Component} from 'react'
import {Layout} from 'antd';
import {Switch, Route, Redirect} from 'react-router-dom'

import userUtils from '../../utills/userUtils'

import SiderMenu from '../../components/sider/sider'
import HeaderMenu from '../../components/header/header'
import Contract from '../domestic-order/contract-modal'
import DomesticOrderList from '../domestic-order/domestic-order-list'
import DomesticOrder from '../domestic-order/domestic-order'
import DomesticOrderDetail from '../domestic-order-detail/domestic-order-detail'
import OrderTicket from '../order-ticket/order-ticket'
import TrackList from '../track-list/track-list'
import TrackEdit from '../track-edit'
import MainPage from '../main-page/main-page'
import TrackInfo from '../trackInfo/trackInfo'
import OrderInfo from '../order-info/order-info'
import AddrList from '../address/addr-list'
import AddrAdd from '../address/addr-add'
import BarcodeList from '../barcode/barcode-list'
import BarcodeAdd from '../barcode/barcode-add'
import DeliveryList from '../delivery-info/delivery-list'
import ImportDeliveryList from '../import-delivery-info/import-delivery-list'
import DeliveryDetail from '../delivery-info/delivery-detail'
import ImportDeliveryDetail from "../import-delivery-info/import-delivery-detail";
import DeliveryEdit from '../delivery-info/delivery-edit'
import './main.less'
import UserSublistForm from "../subscribe/user-sublist";
import OrderSubForm from "../subscribe/order-sub-set";
import Timeliness from '../analysis/timeliness'
import ClientBillTabs from '../bill/client-bill-tabs'
import ReimburseTabs from '../bill/reimburse-tabs'
import ImportOrder from "../import-order/import-order";
import ImportOrderList from "../import-order/import-order-list";
import ImportOrderInfoView from "../import-order/index-view";

const {Content, Footer} = Layout;

export default class Main extends Component {
    render() {

        const user = userUtils.user
        // 如果内存没有存储user ==> 当前没有登录
        if (!user) {
            // 自动跳转到登录(在render()中)
            return <Redirect to='/login'/>
        }
        return (
            <Layout style={{minHeight: '100%'}}>
                <SiderMenu/>
                <Layout>
                    <HeaderMenu/>
                    <Content
                        style={{
                            margin: '24px 16px',
                            padding: 24,
                            background: '#fff',
                            minHeight: 280,
                        }}
                    >
                        <Switch>
                            <Route path='/contract' component={Contract}/>
                            <Route path='/domesticList' component={DomesticOrderList}/>
                            <Route path='/domesticOrder' component={DomesticOrder}/>
                            <Route path='/domesticOrderDetail' component={DomesticOrderDetail}/>
                            <Route path='/orderTicket' component={OrderTicket}/>
                            <Route path='/trackInfo' component={TrackInfo}/>
                            <Route path='/orderInfo' component={OrderInfo}/>
                            <Route path='/trackEdit' component={TrackEdit}/>
                            <Route path='/trackList' component={TrackList}/>
                            <Route path='/addrList' component={AddrList}/>
                            <Route path='/deliveryList' component={DeliveryList}/>
                            <Route path='/importDeliveryList' component={ImportDeliveryList}/>
                            <Route path='/importDeliveryDetail' component={ImportDeliveryDetail}/>
                            <Route path='/deliveryDetail' component={DeliveryDetail}/>
                            <Route path='/deliveryEdit' component={DeliveryEdit}/>
                            <Route path='/addrAdd' component={AddrAdd}/>
                            <Route path='/barcodeAdd' component={BarcodeAdd}/>
                            <Route path='/barcodeList' component={BarcodeList}/>
                            <Route path='/usersub' component={UserSublistForm}/>
                            <Route path='/ordersub' component={OrderSubForm}/>
                            <Route path='/bill/clientList' component={ClientBillTabs}/>
                            <Route path='/bill/reimburseList' component={ReimburseTabs}/>
                            <Route path='/timeliness/:deliveryType' component={Timeliness}/>
                            <Route path='/import/order' component={ImportOrder}/>
                            <Route path='/import/orderView' component={ImportOrderInfoView}/>
                            <Route path='/import/orderList' component={ImportOrderList}/>
                            <Route path='/' component={MainPage}/>
                        </Switch>
                    </Content>
                    {/*<Footer style={{ textAlign: 'center' }}>阳光捷通(北京)贸易服务有限公司</Footer>*/}
                </Layout>
            </Layout>
        )
    }
}